import { Controller } from "@hotwired/stimulus"

// Conversation d'une réclamation (espace élève).
// L'envoi est fait par Turbo (le contrôleur répond 204) et l'affichage du message
// vient du broadcast du modèle : ici on ne fait que présenter le fil — classification
// « mes messages / les leurs », auto-scroll, et remise à zéro du formulaire.
// Le fil est append-only : aucune suppression, aucune édition.
export default class extends Controller {
  static targets = ["messages", "files"]
  static values = { currentUserId: Number }

  connect() {
    this.classifyAllMessages()
    this.scrollToBottom()
    this.observeNewMessages()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  // Vide le formulaire après un envoi accepté (204). Un échec de validation renvoie
  // un Turbo Stream qui remplace le formulaire : on ne touche à rien.
  reset(event) {
    if (!event.detail.success) return

    const editor = this.element.querySelector("lexxy-editor")
    if (editor) editor.value = ""

    if (this.hasFilesTarget) this.filesTarget.value = ""
  }

  // --- Présentation du fil ---

  classifyAllMessages() {
    if (!this.hasMessagesTarget) return

    this.messagesTarget
      .querySelectorAll(".student-chat-msg")
      .forEach(message => this.classifyMessage(message))
  }

  classifyMessage(element) {
    if (!element.classList?.contains("student-chat-msg")) return
    if (element.classList.contains("student-chat-msg--own") ||
        element.classList.contains("student-chat-msg--other")) return

    const authorId = parseInt(element.dataset.userId, 10)
    const isOwn = authorId === this.currentUserIdValue

    element.classList.add(isOwn ? "student-chat-msg--own" : "student-chat-msg--other")
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }

  // Les messages arrivent par Turbo Stream : on les classe et on scrolle à mesure.
  observeNewMessages() {
    if (!this.hasMessagesTarget) return

    this.observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) this.classifyMessage(node)
        }
      }
      this.scrollToBottom()
    })

    this.observer.observe(this.messagesTarget, { childList: true })
  }
}
